import { domainOf, safeExternalUrl } from '../../lib/url';
import type { NewsItemRead } from '../../types/api';
import { articleTopic, type GenerationPrefill } from '../generation/generationPrefill';

/** The publication an item names, else its domain — the same fact either way. */
export function newsSourceName(item: Pick<NewsItemRead, 'source' | 'url'>): string {
  return item.source.trim() || (domainOf(item.url) ?? 'Unknown source');
}

/**
 * The brief an article hands to `/generation`, or null when its URL is not one
 * the research node could fetch — an article that cannot be read is nothing to
 * ground a post on, so the action is not offered at all.
 *
 * Shared by the news page and the home screen's feed panel, so the two
 * "Generate post" buttons cannot drift. Building it spends nothing: the quota
 * goes when the brief is submitted.
 */
export function newsItemPrefill(item: NewsItemRead): GenerationPrefill | null {
  const href = safeExternalUrl(item.url);
  if (href === null) return null;
  return {
    source_url: href,
    topic: articleTopic(item),
    title: item.title,
    source: newsSourceName(item),
  };
}
